@if (animal?.sex === 'male') {
  <span class="sex-icon" [pTooltip]="'male' | transloco" tooltipPosition="top">
    <i class="pi pi-mars"></i>
  </span>
}

@if (animal?.sex === 'female') {
  <span class="sex-icon" [pTooltip]="'female' | transloco" tooltipPosition="top">
    <i class="pi pi-venus"></i>
  </span>
}
